import { ClassificationModel } from 'interfaces/classificationModel';
import { apiRequestHandlerPromise } from 'utils/apiRequestHandler';

export const getClassificationModelOptions = () => {
  return apiRequestHandlerPromise<ClassificationModel[]>({
    url: `classification_models`,
    method: 'GET',
  });
};
